"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VirtualConnectionTablesDisplayGrid = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var react_1 = __importDefault(require("react"));
var Localize_1 = require("../../../gen-src/Localize");
var queries_1 = require("../../../gen-src/queries");
var ObfuscatedCellFormatter_1 = require("../datagrid/cellFormatters/ObfuscatedCellFormatter");
var shouldBeObfuscated = function (_a) {
    var name = _a.name;
    return name === null;
};
var rowDataFunctions = {
    getAssetUrlFromRowData: function (urls, _a) {
        var vizportalUrlId = _a.vizportalUrlId;
        return urls.virtualConnectionTableUrl(vizportalUrlId);
    },
    getNameFromRowData: function (_a) {
        var name = _a.name;
        return name || '';
    },
    getTypeNameFromRowData: function () { return 'VirtualConnectionTable'; },
    getDataQualityCertificationFromRowData: function (_a) {
        var dataQualityCertifications = _a.dataQualityCertifications;
        return dataQualityCertifications;
    }
};
function columns(siteUrls) {
    var columns = [
        function () { return createLabelCertificationColumnFormatter(siteUrls); },
        function () { return ({
            name: 'certification',
            dataKey: '',
            headerText: '',
            headerTooltip: Localize_1.Messages.Certification(),
            headerFormatter: data_catalog_shared_1.DataQualityIconHeaderCertificationFormatterFactory,
            cellFormatter: (0, data_catalog_shared_1.createDataQualityCellFormatter)({
                getWarningsFromRowData: function (_a) {
                    var dataQualityWarnings = _a.dataQualityWarnings;
                    return dataQualityWarnings;
                },
                disableIconOnlyTabIndex: true,
                isCertification: true,
                rowDataFunctions: rowDataFunctions,
            }),
            sortable: false,
            resizable: false,
        }); },
        function () { return createLabelWarningColumnFormatter(siteUrls); },
        function () { return ({
            name: 'warning',
            dataKey: '',
            headerText: '',
            headerTooltip: Localize_1.Messages.DataQualityWarningTitle(),
            headerFormatter: data_catalog_shared_1.DataQualityIconHeaderFormatterFactory,
            cellFormatter: (0, data_catalog_shared_1.createDataQualityCellFormatter)({
                getWarningsFromRowData: function (_a) {
                    var dataQualityWarnings = _a.dataQualityWarnings;
                    return dataQualityWarnings;
                },
                disableIconOnlyTabIndex: true,
                isCertification: false,
                rowDataFunctions: rowDataFunctions,
            }),
            sortable: false,
            resizable: false,
        }); },
        function (params) { return ({
            name: 'name',
            dataKey: queries_1.VirtualConnectionTableOrderField.NAME,
            headerText: Localize_1.Messages.GridHeaderName(),
            headerFormatter: (0, data_catalog_shared_1.createSortableHeaderFormatter)(params),
            cellFormatter: (0, ObfuscatedCellFormatter_1.createObfuscatedLinkCellFormatter)(shouldBeObfuscated, function (_a) {
                var name = _a.name;
                return name;
            }, function (urls, _a) {
                var vizportalUrlId = _a.vizportalUrlId;
                return urls.virtualConnectionTableLineagePath(vizportalUrlId);
            }, undefined, // noPadding
            true // disableTabIndex
            ),
            growToFit: true,
            resizable: true,
            sortable: true,
        }); },
        function (sortParams) { return ({
            name: 'workbooks',
            dataKey: queries_1.VirtualConnectionTableOrderField.DOWNSTREAM_WORKBOOKS_COUNT,
            headerText: Localize_1.Messages.GridHeaderWorkbooks(),
            headerFormatter: (0, data_catalog_shared_1.createSortableHeaderFormatter)(sortParams),
            cellFormatter: (0, data_catalog_shared_1.createTextCellFormatter)(function (_a) {
                var downstreamWorkbooksConnection = _a.downstreamWorkbooksConnection;
                return downstreamWorkbooksConnection
                    ? Localize_1.Formatters.formatCount(downstreamWorkbooksConnection.totalCount)
                    : null;
            }),
            resizable: true,
            sortable: true,
        }); },
        function (sortParams) { return ({
            name: 'datasources',
            dataKey: queries_1.VirtualConnectionTableOrderField.DOWNSTREAM_DATASOURCES_COUNT,
            headerText: Localize_1.Messages.GridHeaderDatasources(),
            headerFormatter: (0, data_catalog_shared_1.createSortableHeaderFormatter)(sortParams),
            cellFormatter: (0, data_catalog_shared_1.createTextCellFormatter)(function (_a) {
                var downstreamDatasourcesConnection = _a.downstreamDatasourcesConnection;
                return downstreamDatasourcesConnection
                    ? Localize_1.Formatters.formatCount(downstreamDatasourcesConnection.totalCount)
                    : null;
            }),
            resizable: true,
            sortable: true,
        }); },
        function (sortParams) { return ({
            name: 'extractStatus',
            dataKey: data_catalog_shared_1.UnsortableColumnKey,
            cellFormatter: (0, data_catalog_shared_1.createTextCellFormatter)(function (_a) {
                var isExtracted = _a.isExtracted;
                return isExtracted
                    ? Localize_1.Messages.ExtractConnection()
                    : Localize_1.Messages.LiveConnection();
            }),
            headerText: Localize_1.Messages.GridHeaderConnectionStatus(),
            headerFormatter: (0, data_catalog_shared_1.createSortableHeaderFormatter)(sortParams),
            sortable: false,
        }); },
    ];
    return columns.filter(Boolean);
}
function VirtualConnectionTablesDisplayGrid(props) {
    var labelsInMorePlacesEnabled = react_1.default.useContext(data_catalog_shared_1.FeatureFlagsContext).labelsInMorePlacesEnabled;
    var siteUrls = react_1.default.useContext(data_catalog_shared_1.SiteUrlsContext);
    var cols = columns(siteUrls)
        .map(function (columnFactory) { return columnFactory(props); })
        .filter(function (column) {
        if (!labelsInMorePlacesEnabled &&
            (column.name === 'label-warning' || column.name === 'label-certification')) {
            return false;
        }
        if (labelsInMorePlacesEnabled &&
            (column.name === 'warning' || column.name === 'certification')) {
            return false;
        }
        return true;
    });
    return (react_1.default.createElement(data_catalog_shared_1.ExplorerStyledDisplayGrid, { columns: cols, rowStore: props.rowStore, emptyGridMessage: props.emptyGridMessage, rowCount: props.rowCount, renderErrors: data_catalog_shared_1.reportGraphQLErrors, orderBy: props.orderBy, updateSortOrder: props.updateSortOrder }));
}
exports.VirtualConnectionTablesDisplayGrid = VirtualConnectionTablesDisplayGrid;
function getLabelContentFromRowData(rowData, urls) {
    var _a;
    return {
        contentId: rowData.id,
        contentLuid: rowData.luid,
        contentType: rowData.contentType,
        contentName: (_a = rowData.name) !== null && _a !== void 0 ? _a : undefined,
        contentUrl: urls.virtualConnectionTableLineageUrl(rowData.vizportalUrlId),
        subjectArea: rowData.__typename
    };
}
function createLabelCertificationColumnFormatter(urls) {
    function getCertificationPropsFromRowData(rowData) {
        var dataQualityCertifications = rowData.dataQualityCertifications;
        var isActive = dataQualityCertifications.some(function (t) { return t.isActive; });
        return {
            catalogEnabled: true,
            content: getLabelContentFromRowData(rowData, urls),
            probablyOrEager: isActive ? { certified: true } : undefined,
            testId: 'virtualconnection-tables-certification-column',
            controls: {
                kind: 'icon',
                siteUrls: urls,
            }
        };
    }
    return (0, data_catalog_shared_1.createLabelColumnFormatter)('certification', { overrides: {}, getPropsFromRowData: getCertificationPropsFromRowData });
}
function createLabelWarningColumnFormatter(urls) {
    function getWarningPropsFromRowData(rowData) {
        var dataQualityWarnings = rowData.dataQualityWarnings ? rowData.dataQualityWarnings : [];
        var isActive = dataQualityWarnings.some(function (warning) { return warning.isActive; });
        var severity = dataQualityWarnings.some(function (warning) { return warning.isActive && warning.isSevere; });
        return {
            catalogEnabled: true,
            content: getLabelContentFromRowData(rowData, urls),
            probablyOrEager: isActive ? {
                warning: {
                    kind: 'warning',
                    severe: severity
                }
            } : undefined,
            testId: 'virtualconnection-tables-warning-column',
            controls: {
                kind: 'icon',
                siteUrls: urls,
            }
        };
    }
    return (0, data_catalog_shared_1.createLabelColumnFormatter)('warning', { overrides: {}, getPropsFromRowData: getWarningPropsFromRowData });
}
//# sourceMappingURL=VirtualConnectionTablesDisplayGrid.js.map